import { render, staticRenderFns } from "./edittaman.vue?vue&type=template&id=33691ec7&"
import script from "./edittaman.vue?vue&type=script&lang=js&"
export * from "./edittaman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports